import { motion } from 'framer-motion'

interface HeroPreviewProps {
  content: {
    title: string
    subtitle: string
    description: string
    subDescription: string
    cta: string
  }
}

export default function HeroPreview({ content }: HeroPreviewProps) {
  return (
    <div className="relative rounded-lg overflow-hidden border border-gray-200 bg-gray-900">
      {/* Simplified Hero Preview */}
      <div className="relative p-6">
        <div className="max-w-lg p-4 bg-black/30 backdrop-blur-sm rounded-lg">
          <h1>
            <span className="block text-xl font-extrabold text-white sm:text-2xl">
              {content.title}
            </span>
            <span className="mt-1 block text-lg font-bold text-primary-600 sm:text-xl">
              {content.subtitle}
            </span>
          </h1>

          <div className="mt-4 space-y-1">
            <p className="text-base font-medium text-white">
              {content.description}
            </p>
            <p className="text-sm text-white/90">
              {content.subDescription}
            </p>
          </div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="mt-4 inline-block rounded-md bg-primary-600 px-4 py-2 text-center text-xs font-semibold uppercase tracking-wider text-white"
          >
            {content.cta}
          </motion.div>
        </div>
      </div>
    </div>
  )
}
